// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  line-height: 1.6;
  font-weight: 400;
  color: #0f172a;
  background-color: #f4f6fb;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html,
body,
#root {
  height: 100%;
}

*, *::before, *::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  min-height: 100vh;
  background-color: #f4f6fb;
}

a {
  color: #2563eb;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

button {
  border-radius: 8px;
  border: 1px solid transparent;
  padding: 0.55rem 1.25rem;
  font-size: 0.95rem;
  font-weight: 600;
  font-family: inherit;
  background-color: #1d4ed8;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}

button:hover:not(:disabled) {
  background-color: #1e40af;
  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.25);
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

input,
textarea,
select {
  font: inherit;
  border: 1px solid #cbd5f5;
  border-radius: 8px;
  padding: 0.55rem 0.75rem;
  background-color: #fff;
  width: 100%;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

input:focus,
textarea:focus,
select:focus {
  border-color: #2563eb;
  outline: none;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.25);
}

textarea {
  min-height: 72px;
  resize: vertical;
}

pre {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: 'JetBrains Mono', 'Fira Code', monospace;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,0FAA0F;EAC1F,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,4DAA4D;AAC9D;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;EAGE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;EACtB,WAAW;EACX,wDAAwD;AAC1D;;AAEA;;;EAGE,qBAAqB;EACrB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,sBAAsB;EACtB,qDAAqD;AACvD","sourcesContent":[":root {\n  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  line-height: 1.6;\n  font-weight: 400;\n  color: #0f172a;\n  background-color: #f4f6fb;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n}\n\n*, *::before, *::after {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  min-height: 100vh;\n  background-color: #f4f6fb;\n}\n\na {\n  color: #2563eb;\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\nbutton {\n  border-radius: 8px;\n  border: 1px solid transparent;\n  padding: 0.55rem 1.25rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  font-family: inherit;\n  background-color: #1d4ed8;\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 0.2s ease, box-shadow 0.2s ease;\n}\n\nbutton:hover:not(:disabled) {\n  background-color: #1e40af;\n  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.25);\n}\n\nbutton:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\ninput,\ntextarea,\nselect {\n  font: inherit;\n  border: 1px solid #cbd5f5;\n  border-radius: 8px;\n  padding: 0.55rem 0.75rem;\n  background-color: #fff;\n  width: 100%;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\ninput:focus,\ntextarea:focus,\nselect:focus {\n  border-color: #2563eb;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.25);\n}\n\ntextarea {\n  min-height: 72px;\n  resize: vertical;\n}\n\npre {\n  margin: 0;\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-family: 'JetBrains Mono', 'Fira Code', monospace;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
